import { render, staticRenderFns } from "./HotSigns.vue?vue&type=template&id=40237fcb&scoped=true&lang=pug&"
import script from "./HotSigns.vue?vue&type=script&lang=js&"
export * from "./HotSigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40237fcb",
  null
  
)

export default component.exports